import { useMemo } from 'react';
import { Control } from 'react-hook-form';
import { type ConnectedFacility } from '../../../../api';
import { SelectController } from '../../SelectController/SelectController';
import './FacilitySelector.scss';

interface FacilitySelectorProps {
  connectedFacilities: ConnectedFacility[];
  onChange: (selection: { value: string; label: string }) => void;
  control: Control<Record<string, any>>;
  name: string;
}

export const FacilitySelector = ({
  connectedFacilities,
  onChange,
  control,
  name,
}: FacilitySelectorProps) => {
  const options = useMemo(() => {
    return connectedFacilities.map((relationship) => ({
      label: relationship.facility.name ?? '',
      value: relationship.facility.id,
    }));
  }, [connectedFacilities]);

  return (
    <SelectController
      control={control}
      name={name}
      options={options}
      isMulti={false}
      isClearable={true}
      placeholder="Choose Assignment Facility"
      onChange={onChange}
      returnOnlyValue={false}
    />
  );
};
